import { TriggerCreate, TriggerStepCreate } from "@dots-projects/types";
import { Alert, Button, Col, Input, Row, Select, Tooltip } from "antd";
const { Option } = Select;
import { useState } from "react";
import { v4 as uuidv4 } from "uuid";

type Props = {
  workspace: any;
  setNewTrigger: React.Dispatch<React.SetStateAction<TriggerCreate | null>>;
  configuration?: {
    steps: TriggerStepCreate[];
    triggerName: string;
  };
};
export default function ScratchTriggerForm({
  workspace,
  setNewTrigger,
  configuration,
}: Props) {
  // Default view
  const [isAutomationTypeView, setIsAutomationTypeView] = useState(true);
  const [triggerName, setTriggerName] = useState<string>(
    configuration?.triggerName ||
      `${localStorage.getItem("guild-name") as string} flow`
  );
  const [triggerType, setTriggerType] = useState<
    "button_click" | "team_join" | "role_change" | "command" | ""
  >("");

  const triggerTypes = [
    {
      label: "When a new member joins Discord",
      id: "team_join",
    },
    {
      label: "When a user clicks on a button",
      id: "button_click",
    },
    {
      label: "When a member's role is changed",
      id: "role_change",
    },
    {
      label: "When a user invokes a slash command",
      id: "command",
    },
    {
      label: "When an external event is received",
      id: "receive_webhook",
      disabled: true,
    },
  ];

  const createInitialTrigger = async () => {
    const guildId = localStorage.getItem("guild-id") as string;
    let initialTrigger: TriggerCreate = {
      type: "team_join",
      name: triggerName,
      isDraft: true,
      workspace: workspace,
      platform: "discord",
      authorUserId: localStorage.getItem("discord-id") || "",
      communityId: guildId,
      steps: configuration?.steps || [],
    };

    switch (triggerType) {
      case "button_click":
        initialTrigger = {
          ...initialTrigger,
          type: "button_click",
          configs: {
            messages: [
              {
                id: uuidv4(),
                buttonIds: [uuidv4()],
              },
            ],
            $$editorButtonClickContent: {
              htmlMessage:
                "Welcome to the community! Click here to get access to the rest of the server.",
              message:
                "Welcome to the community! Click here to get access to the rest of the server.",
              buttonText: "Button text",
              buttonEmoji: "👋",
              channelId: "$channelId",
            },
          },
        };
        break;

      case "team_join":
        initialTrigger = {
          ...initialTrigger,
          type: "team_join",
        };
        break;

      case "role_change":
        initialTrigger = {
          ...initialTrigger,
          type: "role_change",
          configs: {
            rolesAdded: [],
            rolesRemoved: [],
          },
        };
        break;
      case "command":
        initialTrigger = {
          ...initialTrigger,
          type: "command",
          configs: {
            commandName: "test-command",
            description: "Example command",
            ephemeral: false,
            options: [],
            responseOnError: "Something went wrong, please try again!",
            responseOnComplete: "Success! Please continue.",
          },
        };
    }

    setNewTrigger(initialTrigger);
    // Clean states
    setTriggerName("");
    setTriggerType("");
  };

  const changeView = () => {
    setIsAutomationTypeView(!isAutomationTypeView);
  };

  const automationType = (
    <div className="automation-type">
      <div className="automation-title">Select an entry point</div>

      <div className="automation-description">
        {" "}
        This is what will trigger the automation (e.g onboarding a new member,
        or a help request)!
      </div>

      <Select
        placeholder={"Select an entry point"}
        style={{ width: "300px" }}
        onSelect={setTriggerType}
        value={triggerType}
      >
        {triggerTypes.map((triggerType) => (
          <Option
            key={triggerType.id}
            value={triggerType.id}
            name={triggerType.label}
            disabled={triggerType.disabled}
          >
            {triggerType.disabled && (
              <Tooltip title="Your plan isn’t eligible for this automation. Please contact support">
                {triggerType.label}
              </Tooltip>
            )}
            {!triggerType.disabled && triggerType.label}
          </Option>
        ))}
      </Select>
      <Button
        onClick={changeView}
        disabled={!triggerType}
        className={"automation-button automation-button-text"}
      >
        Continue
      </Button>
    </div>
  );

  const automationName = (
    <div className="automation-name">
      <div className="automation-title">Bot name</div>

      <div className="automation-description">
        {" "}
        You can always change this later, so don’t overthink :)
      </div>

      <Input
        style={{ width: "300px" }}
        onChange={(e) => setTriggerName(e.target.value)}
        value={triggerName}
      />

      <Button
        onClick={createInitialTrigger}
        disabled={!triggerName}
        className={"automation-button automation-button-text"}
      >
        Create bot
      </Button>
    </div>
  );

  return (
    <div>
      <div
        style={{
          width: "60%",
          margin: "60px auto 0 auto",
        }}
      >
        {configuration && (
          <Alert
            message="The live bot (the published one) will be duplicated."
            type="warning"
            showIcon
            style={{ marginBottom: "2rem", textAlign: "center" }}
          />
        )}

        <Row>
          <Col span={12}>
            <div
              className={`trigger-option`}
              onClick={() => setIsAutomationTypeView(true)}
            >
              <div className="option-circle">1</div>
              <div className="">Entry point</div>
            </div>
          </Col>
          <Col span={12}>
            <div
              className={`trigger-option ${
                isAutomationTypeView ? "inactive-step" : ""
              }`}
              onClick={() => {
                if (isAutomationTypeView && triggerType) {
                  setIsAutomationTypeView(false);
                }
              }}
            >
              <div className="option-circle">2</div>
              <div className="">Name of the bot</div>
            </div>
          </Col>
        </Row>
      </div>
      <div className="mt-10 mb-20">
        {isAutomationTypeView ? automationType : automationName}
      </div>
    </div>
  );
}
